// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_EditScheduledMessageInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas/editScheduledMessage
 *
 * Reschedules an existing scheduled message.
 */
import { registerContract } from './validate'

export interface MensagensProgramadas_EditScheduledMessageInput {
mensagem_programada_id: number
scheduled_at: string
}

registerContract('MensagensProgramadas_EditScheduledMessageInput', {
  mensagem_programada_id: { type: 'number',  required: true },
  scheduled_at:           { type: 'string',  required: true },
})
